(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
function createProductBundleId() {
 return globalThis.crypto?.randomUUID?.() || 'derevo-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
}
function productBundleItems(data, options) {
 const quantity = Number(data.get('quantity'));
 const bundleId = createProductBundleId();
 const boardProperties = {};
 data.forEach((value, key) => {
  const match = key.match(/^properties\[(.+)\]$/);
  const propertyValue = String(value).trim();
  if (!match || !propertyValue || match[1].startsWith('Engraving ') || match[1] === 'Second deck colour') return;
  boardProperties[match[1]] = propertyValue;
 });
 boardProperties._derevo_bundle = bundleId;
 boardProperties._derevo_bundle_role = 'board';
 const items = [{id: data.get('id'), quantity, properties: boardProperties}];
 const addonProperties = role => ({'For board': options.boardTitle, '_derevo_bundle': bundleId, '_derevo_bundle_role': role});
 if (options.addEngraving) items.push({id: options.engravingId, quantity, properties: {
  ...addonProperties('engraving'),
  'Engraving font': data.get('properties[Engraving font]'),
  'Engraving side': data.get('properties[Engraving side]'),
  'Engraving message': data.get('properties[Engraving message]')
 }});
 if (options.addSecondDeck) items.push({id: options.secondDeckId, quantity, properties: {
  ...addonProperties('cards'), 'Second deck colour': data.get('properties[Second deck colour]')
 }});
 if (options.addPackage) items.push({id: options.packageId, quantity, properties: addonProperties('package')});
 return items;
}
function initializeProducts(scope) {
 scope.querySelectorAll('.derevo-card-choice').forEach(choice => {
  const select = choice.querySelector('[name="properties[Playing-card colour]"]');
  const form = select ? document.getElementById(select.getAttribute('form')) : null;
  const firstPersonalizationOption = form ? form.querySelector('[data-engraving], [data-second-deck], [data-gift-message], [name="add"]') : null;
  if (form && firstPersonalizationOption && choice.parentElement !== form) {
   form.insertBefore(choice, firstPersonalizationOption);
  }
  const guideTemplate = form?.querySelector('[data-card-colour-guide]');
  if (guideTemplate && select && !choice.querySelector('.theme-card-colour-guide')) {
   choice.querySelectorAll('figure').forEach(figure => figure.remove());
   choice.insertBefore(guideTemplate.content.cloneNode(true), select);
  }
 });

 scope.querySelectorAll('[data-holder-config]').forEach(holder => {
  if (holder.dataset.ready) return;
  holder.dataset.ready = 'true';
  const form = holder.closest('form');
  const nativeWrap = holder.querySelector('[data-holder-native]');
  const nativeSelect = holder.querySelector('[data-holder-variant]');
  const enhanced = holder.querySelector('[data-holder-enhanced]');
  const mixSelect = holder.querySelector('[data-holder-mix]');
  const packInputs = [...holder.querySelectorAll('[data-holder-pack]')];
  const decks = holder.querySelector('[data-holder-decks]');
  const deckInputs = [...holder.querySelectorAll('[data-holder-deck-id]')];
  const total = holder.querySelector('[data-holder-total] strong');
  const totalWrap = holder.querySelector('[data-holder-total]');
  const errorBox = holder.querySelector('[data-holder-error]');
  const button = form.querySelector('[name="add"]');
  const mainPrice = holder.closest('.folding-product-copy').querySelector('.theme-product-price');
  const currency = holder.dataset.currency || 'CAD';
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency}).format(cents / 100);
  const selectedPack = () => packInputs.find(input => input.checked)?.value;
  const refresh = () => {
   const pack = selectedPack();
   [...mixSelect.options].forEach(option => {
    const matches = option.dataset.pack === pack;
    option.hidden = !matches;
    option.disabled = !matches || option.dataset.available !== 'true';
   });
   if (!mixSelect.selectedOptions[0] || mixSelect.selectedOptions[0].disabled) {
    const firstAvailable = [...mixSelect.options].find(option => !option.disabled);
    if (firstAvailable) mixSelect.value = firstAvailable.value;
    else mixSelect.selectedIndex = -1;
   }
   nativeSelect.value = mixSelect.value;
   const selected = nativeSelect.selectedOptions[0];
   const available = selected?.dataset.available === 'true';
   button.disabled = !available;
   button.textContent = available ? holder.dataset.addLabel : holder.dataset.soldOutLabel;
   if (selected && mainPrice) mainPrice.textContent = selected.dataset.priceLabel;
   const basePrice = Number(selected?.dataset.price || 0);
   const cardsPrice = deckInputs.reduce((sum, input) => sum + Number(input.dataset.holderDeckPrice) * Number(input.value || 0), 0);
   total.textContent = formatMoney(basePrice + cardsPrice);
   const url = new URL(location.href);
   if (selected) url.searchParams.set('variant', selected.value);
   history.replaceState(history.state, '', url);
  };
  nativeWrap.hidden = true;
  enhanced.hidden = false;
  packInputs.forEach(input => { input.disabled = false; });
  totalWrap.hidden = false;
  if (decks) decks.hidden = false;
  packInputs.forEach(input => input.addEventListener('change', refresh));
  mixSelect.addEventListener('change', refresh);
  deckInputs.forEach(input => input.addEventListener('input', refresh));
  refresh();

  form.addEventListener('submit', async event => {
   event.preventDefault();
   if (form.dataset.holderSubmitting === 'true' || !form.reportValidity()) return;
   const selected = nativeSelect.selectedOptions[0];
   if (!selected || selected.dataset.available !== 'true') return;
   const items = [{id: Number(selected.value), quantity: 1}];
   for (const input of deckInputs) {
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
     input.setCustomValidity(holder.dataset.error);
     input.reportValidity();
     input.setCustomValidity('');
     return;
    }
    if (quantity > 0) items.push({
     id: Number(input.dataset.holderDeckId),
     quantity,
     properties: {'For holders': selected.dataset.pack + ' / ' + selected.dataset.mix}
    });
   }
   form.dataset.holderSubmitting = 'true';
   button.disabled = true;
   form.setAttribute('aria-busy', 'true');
   errorBox.hidden = true;
   try {
    const response = await fetch(holder.dataset.addUrl, {
     method: 'POST',
     headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
     body: JSON.stringify({items})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || holder.dataset.error);
    const cartUrl = new URL(holder.dataset.cartUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) cartUrl.searchParams.set('preview_theme_id', preview);
    location.assign(cartUrl.href);
   } catch (error) {
    errorBox.textContent = error.message || holder.dataset.error;
    errorBox.hidden = false;
    button.disabled = false;
    form.dataset.holderSubmitting = 'false';
    form.removeAttribute('aria-busy');
   }
  });
 });

 scope.querySelectorAll('[data-package]').forEach(packageBox => {
  if (packageBox.dataset.ready) return;
  packageBox.dataset.ready = 'true';
  const form = packageBox.closest('form');
  const toggle = packageBox.querySelector('[data-package-toggle]');
  const total = packageBox.querySelector('[data-package-total]');
  const errorBox = packageBox.querySelector('[data-package-error]');
  packageBox.querySelector('label').hidden = false;
  const updateTotal = () => { total.hidden = !toggle.checked; };
  toggle.addEventListener('change', updateTotal);
  updateTotal();
  form.addEventListener('submit', async event => {
   if (!toggle.checked) return;
   event.preventDefault();
   if (form.dataset.submitting === 'true') return;
   const data = new FormData(form);
   const quantity = Number(data.get('quantity'));
   if (!Number.isInteger(quantity) || quantity < 1 || !form.reportValidity()) return;
   const button = form.querySelector('[name="add"]');
   const wasDisabled = button.disabled;
   form.dataset.submitting = 'true';
   button.disabled = true;
   toggle.disabled = true;
   form.setAttribute('aria-busy', 'true');
   errorBox.hidden = true;
   try {
    const response = await fetch(packageBox.dataset.addUrl, {
     method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
     body: JSON.stringify({items: productBundleItems(data, {
      boardTitle: packageBox.dataset.boardTitle, addPackage: true, packageId: packageBox.dataset.addonId
     })})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || packageBox.dataset.error);
    const cartUrl = new URL(packageBox.dataset.cartUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) cartUrl.searchParams.set('preview_theme_id', preview);
    location.assign(cartUrl.href);
   } catch (error) {
    errorBox.textContent = error.message || packageBox.dataset.error;
    errorBox.hidden = false;
   } finally {
    form.dataset.submitting = 'false';
    button.disabled = wasDisabled;
    toggle.disabled = false;
    form.removeAttribute('aria-busy');
   }
  });
 });

 scope.querySelectorAll('[data-gift-message]').forEach(giftBox => {
  if (giftBox.dataset.ready) return;
  giftBox.dataset.ready = 'true';
  const toggle = giftBox.querySelector('[data-gift-message-toggle]');
  const fields = giftBox.querySelector('[data-gift-message-fields]');
  const messageField = giftBox.querySelector('[data-gift-message-field]');
  const count = giftBox.querySelector('[data-gift-message-count]');
  const updateGiftMessage = () => {
   if (messageField.value.length > 300) messageField.value = messageField.value.slice(0, 300);
   fields.hidden = !toggle.checked;
   messageField.disabled = !toggle.checked;
   toggle.setAttribute('aria-expanded', String(toggle.checked));
   count.textContent = String(messageField.value.length);
  };
  toggle.addEventListener('change', updateGiftMessage);
  messageField.addEventListener('input', updateGiftMessage);
  updateGiftMessage();
 });

 scope.querySelectorAll('[data-engraving]').forEach(engravingBox => {
 if (engravingBox.dataset.ready) return;
 engravingBox.dataset.ready = 'true';
  const toggle = engravingBox.querySelector('[data-engraving-toggle]');
  const fields = engravingBox.querySelector('[data-engraving-fields]');
  const total = engravingBox.querySelector('[data-engraving-total]');
  const messageField = engravingBox.querySelector('[name="properties[Engraving message]"]');
  messageField.addEventListener('input', () => {
   const limited = messageField.value.split(/\r?\n/).slice(0, 2).join('\n').slice(0, 60);
   if (messageField.value !== limited) messageField.value = limited;
  });
  const controls = engravingBox.querySelectorAll('[data-engraving-field]');
  const fieldsets = engravingBox.querySelectorAll('[data-engraving-fieldset]');
  const updateEngraving = () => {
   fields.hidden = !toggle.checked;
   total.hidden = !toggle.checked;
   toggle.setAttribute('aria-expanded', String(toggle.checked));
   controls.forEach(control => { control.disabled = !toggle.checked; });
   fieldsets.forEach(fieldset => { fieldset.disabled = !toggle.checked; });
  };
  toggle.addEventListener('change', updateEngraving);
  updateEngraving();
 });

 scope.querySelectorAll('[data-second-deck]').forEach(secondDeckBox => {
  if (secondDeckBox.dataset.ready) return;
  secondDeckBox.dataset.ready = 'true';
  const toggle = secondDeckBox.querySelector('[data-second-deck-toggle]');
  const fields = secondDeckBox.querySelector('[data-second-deck-fields]');
  const colour = secondDeckBox.querySelector('[data-second-deck-colour]');
  const total = secondDeckBox.querySelector('[data-second-deck-total]');
  const updateSecondDeck = () => {
   fields.hidden = !toggle.checked;
   total.hidden = !toggle.checked;
   colour.disabled = !toggle.checked;
   toggle.setAttribute('aria-expanded', String(toggle.checked));
  };
  toggle.addEventListener('change', updateSecondDeck);
  updateSecondDeck();
 });

 scope.querySelectorAll('[data-personalization-config]').forEach(config => {
  if (config.dataset.ready) return;
  config.dataset.ready = 'true';
  const form = config.closest('form');
  const engravingToggle = form.querySelector('[data-engraving-toggle]');
  const secondDeckToggle = form.querySelector('[data-second-deck-toggle]');
  const errorBox = form.querySelector('[data-personalization-error]');
  const selectionTotal = form.querySelector('[data-personalization-total]');
  const quantityField = form.querySelector('[name="quantity"]');
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency: config.dataset.currency || 'CAD'}).format(cents / 100);
  const updateSelectionTotal = () => {
   const addEngraving = Boolean(engravingToggle?.checked);
   const addSecondDeck = Boolean(secondDeckToggle?.checked);
   const quantity = Number(quantityField?.value || 1);
   const unitPrice = Number(config.dataset.basePrice) + (addEngraving ? Number(config.dataset.engravingPrice) : 0) + (addSecondDeck ? Number(config.dataset.secondDeckPrice) : 0);
   selectionTotal.hidden = !addEngraving && !addSecondDeck;
   selectionTotal.querySelector('strong').textContent = formatMoney(unitPrice * (Number.isFinite(quantity) && quantity > 0 ? quantity : 1));
  };
  engravingToggle?.addEventListener('change', updateSelectionTotal);
  secondDeckToggle?.addEventListener('change', updateSelectionTotal);
  quantityField?.addEventListener('input', updateSelectionTotal);
  updateSelectionTotal();
  form.addEventListener('submit', async event => {
   const addEngraving = Boolean(engravingToggle && engravingToggle.checked);
   const addSecondDeck = Boolean(secondDeckToggle && secondDeckToggle.checked);
   if (!addEngraving && !addSecondDeck) return;
   event.preventDefault();
   if (form.dataset.personalizationSubmitting === 'true') return;
   const data = new FormData(form);
   const quantity = Number(data.get('quantity'));
   if (!Number.isInteger(quantity) || quantity < 1 || !form.reportValidity()) return;
   const button = form.querySelector('[name="add"]');
   const wasDisabled = button.disabled;
   form.dataset.personalizationSubmitting = 'true';
   button.disabled = true;
   if (engravingToggle) engravingToggle.disabled = true;
   if (secondDeckToggle) secondDeckToggle.disabled = true;
   form.setAttribute('aria-busy', 'true');
   errorBox.hidden = true;
   try {
    const items = productBundleItems(data, {
     boardTitle: config.dataset.boardTitle, addEngraving, addSecondDeck,
     engravingId: config.dataset.engravingAddonId, secondDeckId: config.dataset.secondDeckAddonId
    });
    const response = await fetch(config.dataset.addUrl, {
     method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
     body: JSON.stringify({items})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.dataset.error);
    const cartUrl = new URL(config.dataset.cartUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) cartUrl.searchParams.set('preview_theme_id', preview);
    location.assign(cartUrl.href);
   } catch (error) {
    errorBox.textContent = error.message || config.dataset.error;
    errorBox.hidden = false;
   } finally {
    form.dataset.personalizationSubmitting = 'false';
    button.disabled = wasDisabled;
    if (engravingToggle) engravingToggle.disabled = false;
    if (secondDeckToggle) secondDeckToggle.disabled = false;
    form.removeAttribute('aria-busy');
   }
  });
 });
 scope.querySelectorAll('[data-variant-select]').forEach(select => { if(select.dataset.ready)return;select.dataset.ready='true';select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('variant',select.value);location.assign(url);}); });
 scope.querySelectorAll('[data-product-image]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>{const gallery=button.closest('.theme-product-gallery');const image=gallery.querySelector('.theme-product-hero');image.src=button.dataset.productImage;image.removeAttribute('srcset');image.alt=button.dataset.imageAlt;gallery.querySelectorAll('[data-product-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});});
}
initializeProducts(document);
document.addEventListener('shopify:section:load',event=>initializeProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-shipping"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-derevo-welcome]');
  if (!root) return;
  const card = root.querySelector('[data-welcome-card]');
  const close = root.querySelector('[data-welcome-close]');
  const openButton = root.querySelector('[data-welcome-open]');
  const success = root.querySelector('[data-welcome-success]');
  const fields = root.querySelector('[data-welcome-fields]');
  const result = root.querySelector('[data-welcome-result]');
  const form = card.querySelector('form');
  const storageKey = 'derevoWelcomeShippingV1';
  const pendingKey = 'derevoWelcomeSignupPendingV2';
  const readState = () => { try { return JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch { return {}; } };
  const saveState = changes => { try { localStorage.setItem(storageKey, JSON.stringify({...readState(), ...changes})); } catch {} };
  const readPending = () => { try { return JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch { return null; } };
  const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch {} };
  const offers = JSON.parse(root.querySelector('[data-welcome-offers]').textContent);
  const country = root.querySelector('[data-welcome-country]');
  const pending = readPending();
  const url = new URL(location.href);
  const hasErrors = result.dataset.hasErrors === 'true';
  const recentSubmission = pending && pending.formId === form.id && offers[pending.region] && Number.isFinite(pending.submittedAt) && Date.now() >= pending.submittedAt && Date.now() - pending.submittedAt < 30 * 60 * 1000;
  const confirmed = result.dataset.nativeSuccess === 'true' || (!hasErrors && url.searchParams.get('customer_posted') === 'true' && recentSubmission);
  const hasCart = Number(root.dataset.cartCount) > 0;
  const destination = hasCart ? root.dataset.cartUrl : root.dataset.shopUrl;
  const discountUrl = code => root.dataset.rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination);
  let region = recentSubmission ? pending.region : root.dataset.region;
  const updateOffer = nextRegion => {
    if (!offers[nextRegion]) return;
    region = nextRegion;
    const offer = offers[region];
    root.dataset.region = region;
    if (country) country.value = region;
    root.querySelectorAll('[data-welcome-copy]').forEach(element => {
      element.textContent = offer[element.dataset.welcomeCopy];
    });
    card.setAttribute('aria-label', offer.title);
    root.querySelector('[data-welcome-tags]').value = 'newsletter,' + offer.tag;
    root.querySelector('[data-welcome-code]').textContent = offer.code;
    const link = root.querySelector('[data-welcome-link]');
    link.href = discountUrl(offer.code);
    if (hasCart) link.textContent = root.dataset.cartLabel;
  };
  updateOffer(region);
  const countryControl = root.querySelector('[data-welcome-country-control]');
  if (countryControl) countryControl.hidden = false;
  if (country) country.addEventListener('change', () => updateOffer(country.value));
  const clearResultUrl = () => {
    const cleanUrl = new URL(location.href);
    ['customer_posted', 'form_type', 'welcome_region', 'welcome_form'].forEach(key => cleanUrl.searchParams.delete(key));
    if (cleanUrl.hash === '#' + form.id || cleanUrl.hash === '#contact_form') cleanUrl.hash = '';
    if (cleanUrl.href !== location.href) history.replaceState(history.state, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  };
  form.addEventListener('submit', () => {
    try { sessionStorage.setItem(pendingKey, JSON.stringify({formId:form.id, region, submittedAt:Date.now()})); } catch {}
    clearResultUrl();
  });
  let manualOpen = false;
  const show = manual => {
    if (document.querySelector('dialog[open]') || document.querySelector('[data-navigation].open')) return false;
    manualOpen = manual;
    card.classList.add('is-floating');
    close.hidden = false;
    openButton.hidden = false;
    if (manual) card.querySelector('[data-welcome-heading]').focus({preventScroll:true});
    return true;
  };
  const dismiss = () => {
    const hadFocus = card.contains(document.activeElement);
    card.classList.remove('is-floating');
    close.hidden = true;
    openButton.hidden = true;
    saveState({dismissedUntil:Date.now() + 7 * 86400000});
    if (hadFocus && manualOpen) root.querySelector('input[type=email]')?.focus({preventScroll:true});
  };
  openButton.addEventListener('click', () => show(true));
  close.addEventListener('click', dismiss);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && card.classList.contains('is-floating')) dismiss(); });
  if (confirmed) {
    fields.hidden = true;
    success.hidden = false;
    saveState({subscribed:true});
    clearPending();
    clearResultUrl();
    if (hasCart) {
      location.replace(discountUrl(offers[region].code));
      return;
    }
    success.scrollIntoView({block:'center'});
    success.focus({preventScroll:true});
    return;
  }
  if (hasErrors) {
    clearPending();
    clearResultUrl();
    form.querySelector('[aria-invalid="true"]')?.focus();
    return;
  }
  if (!recentSubmission) clearPending();
  if (url.searchParams.has('customer_posted') || url.searchParams.has('welcome_region') || url.searchParams.has('welcome_form')) clearResultUrl();
  const state = readState();
  const suppressedPage = ['product', 'cart', 'checkout', 'contact', 'customers'].includes(root.dataset.pageType) || /\/(?:cart|checkouts?|account|challenge)(?:\/|$)/.test(location.pathname) || /\/pages\/contact(?:\/|$)/.test(location.pathname);
  if (state.subscribed || state.dismissedUntil > Date.now() || root.dataset.knownSubscriber === 'true' || root.dataset.popupEnabled !== 'true' || suppressedPage) return;
  let browsed = false;
  let delayReady = false;
  const stopWatching = () => {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('visibilitychange', attempt);
  };
  const attempt = () => {
    if (!browsed || !delayReady || document.visibilityState !== 'visible') return;
    if (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    if (Array.from(document.querySelectorAll('video')).some(video => !video.paused && !video.ended)) return;
    const rect = root.getBoundingClientRect();
    if (rect.top < window.innerHeight) return;
    if (show(false)) stopWatching();
  };
  const onScroll = () => {
    const available = document.documentElement.scrollHeight - window.innerHeight;
    if (available > 0 && window.scrollY / available >= 0.5) browsed = true;
    attempt();
  };
  window.addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('visibilitychange', attempt);
  setTimeout(() => { delayReady = true; onScroll(); }, Math.max(60, Number(root.dataset.popupDelay) || 30) * 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["where-to-find-us"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('derevo-find-us')) {
  customElements.define('derevo-find-us', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-design-mode')) return;
      this.onVisibility = () => this.updateMarkets();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.updateMarkets();
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
    updateMarkets() {
      clearTimeout(this.expiryTimer);
      const now = Date.now();
      let nextExpiry = Infinity;
      this.querySelectorAll('[data-market-card]').forEach(card => {
        const end = Date.parse(card.dataset.endsAt);
        if (!Number.isFinite(end)) return;
        card.hidden = now >= end;
        if (!card.hidden) nextExpiry = Math.min(nextExpiry, end);
      });
      this.querySelectorAll('[data-market-month]').forEach(month => {
        month.hidden = !month.querySelector('[data-market-card]:not([hidden])');
      });
      const empty = this.querySelector('[data-market-empty]');
      if (empty) empty.hidden = Boolean(this.querySelector('[data-market-card]:not([hidden])'));
      if (Number.isFinite(nextExpiry)) {
        this.expiryTimer = setTimeout(() => this.updateMarkets(), Math.max(50, Math.min(60000, nextExpiry - now)));
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
